import Vue from 'vue'
import App from './App.vue'
import router from './router'
Vue.config.productionTip = false
import Element from 'element-ui'
import Pagination from "@/components/Pagination";
// import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/index.css'
import aMap from 'vue-amap'
import i18n from './assets/language/index'
import './api/mock'
import VueAnimateNumber from 'vue-animate-number'
import axios  from 'axios'
import 'swiper/css/swiper.css'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.prototype.axios =axios
Vue.prototype.$EventBus = new Vue()

Vue.use(Element)
Vue.use(aMap)
Vue.use(VueAnimateNumber)
Vue.component('Pagination', Pagination)

window.SeoUpdate = function (seoTitle,SeoKeywords,SeoDescription){
  let _headDom = '',_title='',_meta=''
  _headDom = document.getElementsByTagName('head')[0]
  _title = _headDom.getElementsByTagName('title')[0]
  _meta = _headDom.getElementsByTagName('meta')

  _title.innerText = seoTitle

  for (let index=0; index<_meta.length; index++) {
    switch (_meta[index].name){
      case 'keywords':
        _meta[index].content = SeoKeywords
        break
      case 'description':
        _meta[index].content = SeoDescription
        break
      default:
        break
    }
  }

}

// router.beforeEach((to,from,next) => {
//   document.body.scrollTop = 0
//   document.documentElement.scrollTop = 0
//   window.pageYOffset = 0
//   next()
// })
// router.afterEach((to,from,next) => {
//   window.scrollTo(0,0)
// })

aMap.initAMapApiLoader({
  key: '36067dc8755057a20462b748cb61ac9e',
  plugin: [
    'AMap.Geolocation',
    "AMap.Scale",
    "AMap.ToolBar",
    "AMap.MapType"
  ]
})



// import Cookies from 'js-cookie'
// Vue.use(Element, {
//   size: Cookies.get('size') || 'medium' // set element-ui default size
// })
new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
